import { memo, PropsWithChildren } from 'react';
import cls from 'classnames';

import styles from './Heading.module.css';

interface HeadingProps {
  appearance: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  className?: string;
  bright?: boolean;
  uppercase?: boolean;
  bold?: boolean;
  'aria-label'?: string;
}

function Heading(props: PropsWithChildren<HeadingProps>) {
  const {
    className,
    children,
    bright = true,
    uppercase = false,
    bold = false,
    appearance: HeadingComponent = 'h1',
    'aria-label': ariaLabel,
  } = props;

  return (
    <HeadingComponent
      className={cls(
        styles.heading,
        {
          [styles.headingBright]: bright,
          [styles.headingUppercase]: uppercase,
          [styles.headingBold]: bold,
        },
        className,
      )}
      aria-label={ariaLabel}
    >
      {children}
    </HeadingComponent>
  );
}

export default memo(Heading);
